<template>
    <div :class="classes" :style="{'flex-direction':direction}">
        <slot/>
    </div>
</template>
<script>
const prefixCls = 'wt-box'
export default {
  name: 'wt-box',
  computed: {
    classes () {
      return `${prefixCls}`
    }
  },
  props: {
    direction: {
      type: String,
      default: 'column'
    }
  },

  data () {
    return {}
  }

}
</script>
<style lang="less">
.wt-box {
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
}
</style>
